import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export default function TaskAttachmentsTab({
  taskAttachments,
  handleDownloadAttachment,
  downloadingId,
}) {
  if (taskAttachments.length === 0) {
    return <Alert severity="info">No task attachments found.</Alert>;
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>File</TableCell>
            <TableCell>Created</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taskAttachments.map((attachment, index) => {
            const downloadKey = attachment?.id ?? attachment?.attachment_id ?? index;
            return (
              <TableRow key={downloadKey}>
                <TableCell>
                  {attachment?.document_name ?? attachment?.file_name ?? attachment?.title ?? 'Attachment'}
                </TableCell>
                <TableCell>{attachment?.created_at ?? '—'}</TableCell>
                <TableCell align="right">
                  <Button
                    size="small"
                    onClick={() => handleDownloadAttachment(attachment)}
                    disabled={downloadingId === downloadKey}
                  >
                    {downloadingId === downloadKey ? <CircularProgress size={16} /> : 'Download'}
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
